import * as React from 'react';

import AppStoreLinks from 'components/app-store-links/AppStoreLinks';
import { MobileBanner } from 'components/banners';

import { __t, applyTranslations } from 'utils/language';
import { getPlatform, isLessThanDesktop } from 'utils/mobile-app';

applyTranslations(require('./i18n/profile-creation-side-finished.i18n.json'));

type Props = {};

class ProfileCreationSideFinishedApps extends React.PureComponent<Props> {
  render() {
    const isMobile = isLessThanDesktop();

    return (
      <div className="profile-creation-side-finished-apps">
        <div className="profile-creation-side-finished-apps__heading">
          {
            isMobile ?
              __t('profile_creation_side_finished.apps_heading_mobile') :
              __t('profile_creation_side_finished.apps_heading')
          }
        </div>
        {
          isMobile ?
            <MobileBanner platform={getPlatform()} /> :
            <React.Fragment>
              <div className="profile-creation-side-finished-apps__description">
                {__t('profile_creation_side_finished.apps_description')}
              </div>
              <div className="profile-creation-side-finished-apps__links">
                <AppStoreLinks />
              </div>
            </React.Fragment>
        }
      </div>
    );
  }
}

export default ProfileCreationSideFinishedApps;
